<div class="dropdown" dropdown #dropdown="bs-dropdown" [autoClose]="!modalOpen" [insideClick]="true"
  (onShown)="populateList()" (onHidden)="emptyList()">

  <button id="nav-alert-dropdown-btn" dropdownToggle type="button" class="btn btn-link dropdown-toggle"
    aria-controls="nav-alert-dropdown-list">
    <ng-container *ngIf="unreadCount">
      <span class="badge badge-pill badge-danger">{{ unreadCount }}</span>
      <i class="fas fa-bell-exclamation fa-lg"></i>
    </ng-container>
    <i *ngIf="!unreadCount" class="fal fa-bell fa-lg"></i>
  </button>

  <div *dropdownMenu class="dropdown-menu dropdown-menu-right p-0 shadow-sm">

    <div class="container-fluid default border-bottom">

      <div class="row align-items-center">
        <div class="col-auto">
          <a class="notification-header" [routerLink]="['/notification/received']" (click)="dropdown.hide()"
            title="{{ 'notification.view_received' | translate }}">
            <i class="fa-regular fa-bells"></i>
            {{ 'notification.notifications' | translate }}
          </a>
        </div>

        <div class="col-auto ml-auto">
          <button type="button" class="btn btn-link text-xs" *ngIf="unreadCount && notifications?.length"
            (click)="markAllRead()">
            <i class="fas fa-check-double"></i>
            {{ 'notification.mark_all_read' | translate }}
          </button>

          <button type="button" class="btn btn-link text-xs" *ngIf="!unreadCount && notifications?.length"
            (click)="markAllCleared()">
            <i class="fa-regular fa-times"></i>
            {{ 'notification.clear_all' | translate }}
          </button>
        </div>
      </div>

    </div>

    <div class="container-fluid default notification-list" #notificationList>

      <div class="row py-2" *ngIf="!notifications?.length && !loading">
        <div class="col text-center">
          <span>
            {{ 'notification.no_notifications' | translate }}
          </span>
        </div>
      </div>

      <ng-container *ngIf="notifications?.length">
        <div *ngFor="let notification of notifications" class="row notification-item">

          <div class="col">

            <div class="row align-items-center">
              <div class="col">
                <span class="font-weight-600" [ngClass]="{ 'text-danger' : notification.critical }">
                  {{ notification.title | truncate: 50 }}
                </span>

                <a *ngIf="notification.notificationReferenceType === 10" [routerLink]="['assignment', notification.notificationReferenceId]" title="{{ 'notification.open_assignment' | translate }}">
                  <i class="fa-lg far fa-arrow-square-right"></i>
                </a>
                
              </div>
              <div class="col-auto">
                <span class="small text-muted">
                  {{notification.createdAt | localizedDate: 'short'}}
                </span>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col">
                <p class="notification-message text-xs text-muted mb-0 cursor-pointer"
                  (click)="viewNotification(notification)" title="{{ 'notification.read_notification' | translate }}">
                  {{ notification.message | truncate: 150 }}
                </p>
              </div>

              <div class="col-auto">

                <div class="row gutter-xxs">

                  <!-- <div class="col-auto">
                    <button type="button" class="btn btn-link" (click)="viewNotification(notification)"
                      tooltip="{{ 'notification.read_notification' | translate }}" placement="auto">
                      <i class="fas fa-book-open"></i>
                    </button>
                  </div> -->

                  <div class="col-auto" *ngIf="!notification.readTime">
                    <button type="button" class="btn btn-link width-40"
                      title="{{ 'notification.mark_read' | translate}}" (click)="markRead(notification)">
                      <i class="fas fa-check"></i>
                    </button>
                  </div>

                  <div class="col-auto" *ngIf="notification.readTime">
                    <button type="button" class="btn btn-link width-40" (click)="markCleared(notification)"
                      title="{{ 'notification.clear' | translate}}">
                      <i class="fas fa-times cursor-pointer"></i>
                    </button>
                  </div>
                </div>



              </div>
            </div>

          </div>

        </div>
      </ng-container>

      <div class="row py-2" *ngIf="loading">
        <div class="col text-center">
          <loading-spinner></loading-spinner>
        </div>
      </div>

      <div class="row" *ngIf="hasMore">
        <div class="col">
          <button type="button" class="btn btn-link text-xs w-100" (click)="getPartialNotifications()">
            <i class="fas fa-chevron-down"></i>
            {{ 'common.actions.get_more' | translate }}
          </button>
        </div>
      </div>

    </div>

  </div>

</div>
